import { Button, Col, Row, Spinner } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import IncidentNotifications from "../incidents/incidentnotifications";
import { useIncidentInitialUpsert } from "../../../../new/query";
import useMessageStore from "../../../../stores/message-store";
import IncidentBackupWidget from "../incidents/incidentbackupwidget";
import RHFSelectWithInvalid from "../../../../rhf/rhfselectwithinvalid";
import { useEffect } from "react";

const IncidentInitialNew = ({incident,defintions,medicaidid,hashkey,onCreated = null}) => {
    const initialValues = {
        id: null,
        notifications: [],
        waiverType: '',
        classification: '',
        cDO: '',
        adjudicated: '',
        reportingAgency: '',
        providerNumber: '',
        reportingPerson: '',
        repStaff: '',
        reportingPersonOther: '',
        reportingPersonFirstName: '',
        reportingPersonLastName: '',
        reportingPersonPhone: '',
        caseManagementProvider: '',
        caseManagerName: '',
        guardian: '',
        discoveryinc: '',
        incidentDatetime: '',
        incidentLocation: '',
        incidentLocationOther: '',
        incidentAddress: '',
        incidentCity: '',
        incidentState: '',
        incidentZip: '',
        incidentPhone: '',
        descriptionOfIncident: '',
        whatHappenedBefore: '',
        whatHappenedDuring: '',
        whatHappendedFollowing: '',
        incidentHappenedAgain: '',
        codes: [],
        incidentCodesOther: '',
        incidentDetails: '',
        dateReportCompleted: '',
        dateTimeReportReceived: '',
        emergencyBackupAssistance: [],
        emergencyBackupAssistanceComments: ''
    }

    const _GetFormReset = (data) => {
        const {discovery,incident: incidentext,reportingPersonStaff,...rest} = data;
        let combined = '';
        if(discovery) combined = 'discovery';
        else if(incidentext) combined = 'incident';
        else if (discovery === null && incidentext === null) combined = '';
        return{
            ...rest,
            cDO : rest.cdo === null ? '' : rest.cdo ? 'yes' : 'no',
            adjudicated: rest.adjudicated === null ? '' : rest.adjudicated ? 'yes' : 'no',
            guardian: rest.guardian === null ? '' : rest.guardian ? 'yes' : 'no',
            codes: rest.codes.sort((a,b) => a.localeCompare(b)),
            incidentState: `${rest.incidentState}`,
            repStaff: reportingPersonStaff === null ? '' : `${reportingPersonStaff}`,
            discoveryinc: combined //holds combined values,

        }
    }

    const {register,reset,handleSubmit,control,resetField,watch, formState: {isDirty}} = useForm({
        defaultValues: incident === null
        ? initialValues
        : _GetFormReset(incident)
        // : (() => {
        //     const {discovery,incident: incidentext,...rest} = incident;
        //     let combined = '';
        //     if(discovery) combined = 'discovery';
        //     else if(incidentext) combined = 'incident';
        //     else if (discovery === null && incidentext === null) combined = '';

        //     return{
        //         ...rest,
        //         cDO : rest.cdo === null ? '' : rest.cdo ? 'yes' : 'no',
        //         adjudicated: rest.adjudicated === null ? '' : rest.adjudicated ? 'yes' : 'no',
        //         guardian: rest.guardian === null ? '' : rest.guardian ? 'yes' : 'no',
        //         codes: rest.codes.sort((a,b) => a.localeCompare(b)),
        //         discoveryinc: combined //holds combined values
        //     }
        // })()
    });

    const divideArray = (array, parts) => {
        const result = [];
        const chunkSize = Math.ceil(array.length / parts);
        for (let i = 0; i < parts; i++) {
            result.push(array.slice(i * chunkSize, (i + 1) * chunkSize));
        }
        return result;
      };

      const addToast = useMessageStore(state => state.addToast);

      const submittedCallback = (data) => {
        if(incident === null){
            onCreated(data);
        }
        else{
            const {stage,followup,followupStaff,responseToFollowup,...rest} = data; //Omit parts we do not need
            
            const resetVal = _GetFormReset(rest);
            reset(resetVal);
        } 

        addToast(
            {
                id: Math.random(),
                body: "The Incident was succesfully saved!",
                autoHide: true,
                errorFlag: false,
                timestamp: Date.now() - 1000
            }
        )
    }

    const errorCallback = () => {
        addToast(
            {
                id: Math.random(),
                body: "An Error occured when submitting the Incident.",
                autoHide: true,
                errorFlag: true,
                timestamp: Date.now() - 1000
            }
        )
    }

    const upsertMutation = useIncidentInitialUpsert(incident?.id,medicaidid,submittedCallback,errorCallback);

    const convertNullYesNO = (item) => {
        if(item === null) return null;

        return item === 'yes';
    }


    const _handleSubmit = (data) => {
        const {discoveryinc,...values} = data;
        console.log(data);
        const hasStafffollowupInner = data.reportingPerson !== ""
        ? defintions.reportingperson.find(s => s.id === data.reportingPerson)?.hasstafffollowup : false

        let reportingPersonFirstName = data.reportingPersonFirstName;
        let reportingPersonLastName = data.reportingPersonLastName;
        let repStaff;

        if(hasStafffollowupInner){
            reportingPersonFirstName = null;
            reportingPersonLastName = null;
            repStaff = data.repStaff ? Number(data.repStaff) || null : null;
            
        }
        else{
            repStaff = null;
        }

        const sendData = {
            ...values,
            cDO: convertNullYesNO(data.cDO),
            adjudicated: convertNullYesNO(data.adjudicated),
            guardian: convertNullYesNO(data.guardian),
            incident: discoveryinc === null ? null : discoveryinc === 'incident',
            discovery: discoveryinc === null ? null : discoveryinc === 'discovery',
            reportingPersonFirstName,
            reportingPersonLastName,
            repStaff
        }
        upsertMutation.mutate({MedicaidId: medicaidid,...sendData});
    }

    const repPerson = watch('reportingPerson');

    const hasStafffollowup = repPerson !== ""
        ? defintions.reportingperson.find(s => s.id === repPerson)?.hasstafffollowup : false

    useEffect(() => {
        if(incident === null){
            //Only reset on add but preserve on edit until submit
            if(!hasStafffollowup){
                console.log('here')
                resetField('repStaff',{defaultValue: ''});
            }
        }
    },[hasStafffollowup])

    return(
        <form onSubmit={handleSubmit(_handleSubmit)}>
            <div style={{backgroundColor: 'rgb(219,219,219)',border: '1px dashed black', padding: '4px'}}>
            <Row>
                <Col xs={12}>
                    <Row>
                        <Col xs={12} md={6}>
                        <fieldset>
                            <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>Waiver Type</legend>
                            {
                                defintions.incidentwaivertypes.map((wt) => (
                                    <label key={wt.id} className="me-2">
                                        <input type="radio" {...register('waiverType')} value={wt.id}/>
                                        {wt.name}
                                    </label>
                                ))
                            }
                        </fieldset>
                        <fieldset>
                            <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>Incident Classification</legend>
                            {
                                defintions.classifications.map((cl) => (
                                    <label key={cl.id} className="me-2">
                                        <input type="radio"  value={cl.id} {...register('classification')}/>
                                        {cl.name}
                                    </label>
                                ))
                            }
                        </fieldset>
                        <fieldset>
                            <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>CDO?</legend>
                            <label className="me-2">
                                <input type="radio"  value='yes' {...register('cDO')}/>
                                Yes
                            </label>
                            <label>
                                <input type="radio" value='no' {...register('cDO')} />
                                No
                            </label>
                        </fieldset>
                        <fieldset>
                            <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>Adjudicated</legend>
                            <label className="me-2">
                                <input type="radio" value='yes' {...register('adjudicated')} />
                                Yes
                            </label>
                            <label>
                                <input type="radio" value='no' {...register('adjudicated')} />
                                No
                            </label>
                        </fieldset>
                        </Col>
                        <Col xs={12} md={6}>
                            <Row>
                                <Col xs={12} md={8}>
                                    <label htmlFor="repagency">Reporting Agency</label>
                                    <input id="repagency" type="text" style={{width: '100%'}} {...register('reportingAgency')}/>
                                </Col>
                                <Col xs={12} md={4}>
                                    <label htmlFor="provnum">Provider #</label>
                                    <input id="provnum" type="text" style={{width: '100%'}}  {...register('providerNumber')} />
                                </Col>  
                            </Row>
                            <Row>
                                <Col xs={12} md={6}>
                                    <label htmlFor="reppers">Reporting Person</label>
                                    <select id="reppers" style={{width: '100%',minHeight: '30px'}} {...register('reportingPerson')} >
                                        <option value=''>--Select Reporting Person--</option>
                                        {
                                            defintions.reportingperson.map((rp) => (
                                                <option key={rp.id} value={rp.id}>{rp.name}</option>
                                            ))
                                        }
                                    </select>
                                </Col>
                                <Col xs={12} md={6}>
                                    <label htmlFor="reppersother">Reporting Person Other</label>
                                    <input type="text" id="reppersother" style={{width: '100%'}} {...register('reportingPersonOther')} />
                                </Col>
                                {hasStafffollowup ?
                                    <Col xs={12} md={8}>
                                        <RHFSelectWithInvalid 
                                        name='repStaff'
                                        label='Reporting Staff'
                                        methods={{control}}
                                        refinedOptions={defintions.sttrttusers}
                                        masterOptions={defintions.usermasterlist}
                                        placeholder="--Select User--"
                                        style={{width: '100%',minHeight: '30px'}}        
                                    />
                                    </Col> 
                                    : <>
                                        <Col xs={12} md={4}>
                                            <label htmlFor="reppersfirst">First Name</label>
                                            <input id="reppersfirst" type="text" style={{width: '100%'}} {...register('reportingPersonFirstName')} />
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <label htmlFor="repperslast">Last Name</label>
                                            <input id="repperslast" type="text"  style={{width: '100%'}} {...register('reportingPersonLastName')}/>
                                        </Col>
                                    </>
                                }
                                <Col xs={12} md={4}>
                                    <label htmlFor="reppersphone">Phone #</label>
                                    <input id="reppersphone" type="tel"  style={{width: '100%'}}  {...register('reportingPersonPhone')} />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={6}>
                                    <label htmlFor="casemanprov">Case Management Provider</label>
                                    <input id="casemanprov" type="text"  style={{width: '100%'}} {...register('caseManagementProvider')}/>
                                </Col>
                                <Col xs={12} md={6}>
                                    <label htmlFor="casemanprovname">Case Manager Name</label>
                                    <input id="casemanprovname" type="text" style={{width: '100%'}} {...register('caseManagerName')}/>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <fieldset>
                                    <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>Gaurdian?</legend>
                                    <label className="me-2">
                                        <input type="radio" value='yes' {...register('guardian')}/>
                                        Yes
                                    </label>
                                    <label>
                                        <input type="radio" value='no' {...register('guardian')}/>
                                        No
                                    </label>
                                    </fieldset>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className="mt-4">
                <Col xs={12}>
                    <h5 className="text-center">Incident Information</h5>
                </Col>
                <Col xs={12} md={6}>
                    <Row>
                        <Col xs={12}>
                        <fieldset>
                        <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>Date of</legend>
                            <label className="me-2">
                                <input type="radio"  value='incident' {...register('discoveryinc')} />
                                Incident
                            </label>
                            <label>
                                <input type="radio"  value='discovery' {...register('discoveryinc')} />
                                Discovery
                            </label>
                            <div>
                                <label className="visually-hidden" htmlFor="dateofinc">Date of incident</label>
                                <input id="dateofinc" type="datetime-local"  {...register('incidentDatetime')} />
                            </div>
                        </fieldset>
                        </Col>
                        <Col xs={12}>
                        <label htmlFor="incidentlocation">Location of Incident</label>
                        <select id="incidentlocation" style={{width: '100%',height: '30px'}} {...register('incidentLocation')} >
                            <option value=''>--Select Incident Location--</option>
                            {
                                defintions.incidentlocations.map((rp) => (
                                    <option key={rp.id} value={rp.id}>{rp.name}</option>
                                ))
                            }
                        </select>
                        </Col>
                        <Col xs={12} md={6}>
                                                    <label  htmlFor="addr">Address</label>
                                                    <input id="addr" type="text" style={{width: '100%'}} placeholder="Address" {...register('incidentAddress')} />
                                                </Col>
                                                <Col xs={12} md={6}>
                                                    <label  htmlFor="city">City</label>
                                                    <input id="city" type="text" style={{width: '100%'}} placeholder="City" {...register('incidentCity')} />
                                                </Col>
                                                <Col xs={12} sm={6} md={4}>
                                                <label  htmlFor="state">State</label>
                                                <select id="state" style={{width: '100%',minHeight: '30px'}} {...register('incidentState')} >
                                                    <option value=''>--Select State--</option>
                                                    {
                                                        defintions.states.map((st) => (
                                                            <option key={st.id} value={st.id}>{st.name}</option>
                                                        ))
                                                    }
                                                </select>
                                                </Col>
                                                <Col xs={12} sm={3} md={4}>
                                                   <label htmlFor="zip">Zip</label>
                                                   <input id="zip" type="text"  style={{width: '100%'}} {...register('incidentZip')} />
                                                </Col>
                                                <Col xs={12} sm={3} md={4}>
                                                   <label htmlFor="tel">Phone #</label>
                                                   <input id="tel" type="tel"  style={{width: '100%'}} {...register('incidentPhone')} />
                                                </Col>
                                                <Col xs={12} md={12}>
                                                   <label htmlFor="other">Other</label>
                                                   <input id="other" type="text"  style={{width: '100%'}} {...register('incidentLocationOther')} />
                                                </Col>  
                    </Row>           
                </Col>
                <Col xs={12} md={6}>
                    <IncidentNotifications control={control} notificationtypes={defintions.notificationto}/>
                </Col>
            </Row>
            <Row className="mt-4">
                                <Col xs={12}>
                                    <h5 className="text-center">Incident Details</h5>
                                </Col>
                                <Col xs={12}>
                                    <label htmlFor="descinc">Description of Incident</label>
                                    <textarea id="descinc"  style={{width: '100%'}} rows={6} {...register('descriptionOfIncident')}/>
                                </Col>
                                <Col xs={12}>
                                    <label htmlFor="imminc">What happened immediately before the incident?</label>
                                    <textarea id="imminc"  style={{width: '100%'}} rows={6} {...register('whatHappenedBefore')} />
                                </Col>
                                <Col xs={12}>
                                    <label htmlFor="duringinc">What happened during the incident?</label>
                                    <textarea id="duringinc"  style={{width: '100%'}} rows={6} {...register('whatHappenedDuring')} />
                                </Col>
                                <Col xs={12}>
                                    <label htmlFor="followinc">What happened immediately following the incident?</label>
                                    <textarea id="followinc"  style={{width: '100%'}} rows={6} {...register('whatHappendedFollowing')} />
                                </Col>
                                <Col xs={12}>
                                    <label htmlFor="diffinc">If the incident happened again, what would you do differently?</label>
                                    <textarea id="diffinc" style={{width: '100%'}} rows={6} {...register('incidentHappenedAgain')} />
                                </Col>
                            </Row>
            <Row className="mt-4">
                <Col xs={12}>
                    <fieldset>
                        <legend className="fw-bold text-center" style={{fontSize: '1rem',marginBottom: '0'}}>Incident Codes (select all that apply)</legend>
                        <Row>
                        <Controller 
                            control={control}
                            name="codes"
                            render={({field}) => (
                                divideArray(defintions.incidentcodes,3).map((item,index) => (
                                    <Col xs={12} lg={4} key={index}>
                                        {item.map((val) => (
                                            <div key={val.id}>
                                                <label>
                                                <input type="checkbox" id={`codes-${val.id}`} value={val.id} checked={field.value.includes(val.id)}
                                                    onChange={(e) => {
                                                                                        const value = e.target.value;

                                                                                        if(e.target.checked){
                                                                                            field.onChange([...field.value,value].sort((a,b) => a.localeCompare(b)));
                                                                                        }
                                                                                        else{
                                                                                            field.onChange(field.value.filter((id) => id !== value));
                                                                                        }
                                                                                }}
                                                    />
                                                    {val.name}
                                                </label>
                                            </div>
                                        ))}
                                    </Col>
                                ))
                            )}
                        />
                        <Col xs={12}>
                            <label htmlFor="incidentcodeother">Incident Codes (Other)</label>
                            <input type="text" id="incidentcodeother" style={{width: '100%'}} {...register('incidentCodesOther')} />
                        </Col>
                        </Row>
                    </fieldset>
                </Col>
            </Row>
            <Row className="mt-4">
                 <Col xs={12} md={9}>
                    <IncidentBackupWidget control={control} definitions={defintions}/>
                 </Col>
                 <Col xs={12} md={3}>
                    <textarea id="emergencyBackupAssistanceComments" {...register('emergencyBackupAssistanceComments')} rows={13} style={{width: '100%'}} placeholder="Emergency Backup Comments" />
                 </Col>           
            </Row>
            <Row className="mt-4">
                                <Col xs={12}>
                                    <h5 className="text-center">Additional Information</h5>
                                </Col>
                                <Col xs={12}>
                                    <label htmlFor="incdet">Incident Details</label>
                                    <textarea id="incdet"  style={{width: '100%'}} rows={6} {...register('incidentDetails')} />
                                </Col>
                                <Col xs={12}>
                                    <label htmlFor="incidentrepdate" className="me-1">
                                        Date Incident Report Completed
                                    </label>
                                    <input id="incidentrepdate" type="date" {...register('dateReportCompleted')} />
                                </Col>
                                <Col xs={12}>
                                <label className="me-1" htmlFor="increc">Date & Time Incident Report Received</label>
                                <input id="increc" type="datetime-local" {...register('dateTimeReportReceived')} />
                                </Col>
                            </Row>
            <Row className="mt-4">
                <Col xs={12}>
                    <div className="d-flex justify-content-end">
                        <Button type="submit" variant={incident ? "primary" : 'success'} disabled={upsertMutation.isPending || (incident ? !isDirty : false)}>
                            {
                                upsertMutation.isPending
                                ?
                                    <Spinner animation='border' size='sm' />
                                :
                                    incident
                                    ?
                                        <>Save Changes</>
                                    :
                                        <>Add Incident</>
                            }
                        </Button>
                    </div>
                </Col>
            </Row>
            </div>
        </form>
    )
}

export default IncidentInitialNew;